module.exports = __webpack_public_path__ + "static/media/bird-loon1.006d80db.aac";